/**
 * `logo_wall` — a row of partner / brand / certification logos (module 22 D3).
 *
 * Presentation only. Logos are merchant-uploaded images (spec 42 R6), shown at
 * a capped height so mixed aspect ratios line up. Optional greyscale is the
 * common trust-row treatment; it lifts on hover. Class-free (see `index.ts`).
 */
import { SectionHeading } from "./section-heading.js";

export function LogoWall({
  heading,
  items,
  grayscale,
}: {
  heading?: string | undefined;
  items: Array<{ imageUrl: string; alt?: string | undefined }>;
  grayscale: boolean;
}) {
  return (
    <section aria-label={heading ?? "Our partners"}>
      {heading ? <SectionHeading>{heading}</SectionHeading> : null}
      <div className={`flint-logo-wall ${grayscale ? "flint-logo-gray" : ""}`}>
        {items.map((it, i) =>
          it.imageUrl ? (
            <div key={i} className="flint-logo-tile">
              <img src={it.imageUrl} alt={it.alt ?? ""} loading="lazy" />
            </div>
          ) : (
            // Empty slot (a just-added logo) — a token-textured box, never a
            // broken image on a public page.
            <div
              key={i}
              className="flint-logo-tile"
              style={{ height: 44, width: "100%", background: "var(--bg)", borderRadius: "var(--r-sm)" }}
              aria-hidden
            />
          ),
        )}
      </div>
    </section>
  );
}
